function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import TextCell from "../cell/TextCell";
import IconCell from "../cell/IconCell";
import PlusIcon from "../common/PlusIcon";
import { ExpandedTableRow } from "./ExpandedTableRow";
const TableRowCell = _ref => {
  let {
    content
  } = _ref;
  const cellData = content.cellData;
  if ("icon" in cellData) {
    return /*#__PURE__*/React.createElement(IconCell, content);
  } else {
    return /*#__PURE__*/React.createElement(TextCell, content);
  }
};
const TableRow = _ref2 => {
  let {
    rowContent,
    expandedRowContent,
    highlightRow = false,
    rowRef,
    isExpanded,
    toggleExpanded
  } = _ref2;
  function handleRowClick(event) {
    const clickedTarget = event.target;
    const buttonElement = clickedTarget.closest("button");
    if (buttonElement && isExpanded) {
      buttonElement.blur();
    }
    toggleExpanded();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: classNames("table-row", "button-reset", {
      "is-active": isExpanded,
      highlighted: highlightRow
    }),
    onClick: handleRowClick,
    ref: rowRef
  }, rowContent && rowContent.map((content, index) => /*#__PURE__*/React.createElement(TableRowCell, {
    key: index,
    content: content
  })), expandedRowContent && /*#__PURE__*/React.createElement(PlusIcon, {
    isActive: isExpanded
  })), isExpanded && expandedRowContent && /*#__PURE__*/React.createElement(ExpandedTableRow, null, expandedRowContent));
};
const TableBody = _ref3 => {
  let {
    tableBodyContent,
    targetRowIndex,
    targetRowRef,
    onExpandedRow
  } = _ref3;
  const [expandedRows, setExpandedRows] = useState(() => Object.fromEntries(tableBodyContent.map(value => [value.rowId, value.defaultExpanded || false])));
  useEffect(() => {
    setExpandedRows(prevExpandedRows => {
      const updatedExpandedRows = {
        ...prevExpandedRows
      };
      tableBodyContent.forEach(value => {
        const {
          rowId,
          defaultExpanded
        } = value;
        if (defaultExpanded !== undefined && prevExpandedRows[rowId] !== defaultExpanded) {
          updatedExpandedRows[rowId] = defaultExpanded;
        }
      });
      return updatedExpandedRows;
    });
  }, [tableBodyContent]);
  const toggleExpanded = rowId => {
    setExpandedRows(prevExpandedRows => ({
      ...prevExpandedRows,
      [rowId]: !prevExpandedRows[rowId]
    }));
    if (onExpandedRow) {
      onExpandedRow(rowId, expandedRows[rowId]);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "table-body"
  }, tableBodyContent.map((content, index) => /*#__PURE__*/React.createElement(TableRow, _extends({}, content, {
    key: content.rowId,
    rowRef: index === targetRowIndex ? targetRowRef : undefined,
    isExpanded: expandedRows[content.rowId],
    toggleExpanded: () => {
      toggleExpanded(content.rowId);
    }
  }))));
};
export default TableBody;